module.exports = __webpack_public_path__ + "img/Closed.4465f4a2.gif";